require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quarterly-newsletter-june.json") })
        }
      }, "path---quarterly-newsletter-june");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quarterly-newsletter-june!./.cache/json/quarterly-newsletter-june.json
// module id = 1173
// module chunks = 231608221292675